import { FC, ReactNode, Suspense, useState } from 'react'
import { MenuOutlined } from '@maas-components/icons'
import { useTranslation } from 'react-i18next'
import { VERSION } from 'common/constants/env'
import Loading from 'components/Loading'
import { TDrawerOptions } from 'components/SideBar/types'
import { getRolesStore, useRolesStore } from '../../common/store/roles'
import AppHeader from '../AppHeader'
import AppSidebar from '../AppSidebar'
import initialLinks from './links'

export interface AppShellProps {
  children: NonNullable<ReactNode>
  header?: boolean
}

const AppShell: FC<AppShellProps> = ({ header, children }) => {
  const { t } = useTranslation()
  const isOpen = false

  const [options, setOptions] = useState<TDrawerOptions>({
    isOpen,
    isOpenFromMenu: true,
  })

  const { roles } = useRolesStore(getRolesStore)

  const links = [...initialLinks]
  const filteredLinks = links.filter(
    link => !link.roles || link.roles.some(role => roles.includes(role))
  )

  const menu = {
    title: {
      icon: <MenuOutlined />,
      name: t('sidebar.title'),
    },
    links: filteredLinks.map(link => ({
      name: t(link.name),
      url: link.url,
      icon: link.icon,
      links: link.links?.map(sublink => ({
        name: t(sublink.name),
        url: sublink.url,
      })),
    })),
  }

  const renderHeader = header ? <AppHeader options={options} setOptions={setOptions} /> : null

  return (
    <Suspense fallback={<Loading />}>
      {renderHeader}
      <AppSidebar menu={menu} version={VERSION} options={options} setOptions={setOptions}>
        {children}
      </AppSidebar>
    </Suspense>
  )
}

export default AppShell
